import { PropsWithChildren } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { AdminFormSection } from '@ui';
import { TMDXFile } from '@/api/apis/files';

export type FacilityAdminFormValues = {
  name?: string;
  image?: TMDXFile;
  logoPath?: string;
  country?: string;
  state?: string;
  code?: string;
};

type FacilityAdminFormSectionProps = PropsWithChildren<{
  title: string;
  isReadOnly?: boolean;
}>;

export const FacilityAdminFormSection = ({ title, isReadOnly = false, children }: FacilityAdminFormSectionProps) => {
  const { control, setValue } = useFormContext<FacilityAdminFormValues>();

  const [logoPath, code, name, state] = useWatch({
    control,
    name: ['logoPath', 'code', 'name', 'state'],
  });

  const onImageChange = (file: TMDXFile) => {
    setValue('image', file);
  };

  return (
    <AdminFormSection
      title={title}
      withAvatar
      imageUrl={logoPath}
      onImageChange={onImageChange}
      isReadOnly={isReadOnly}
      type="facility"
      name={code || name || state}
    >
      {children}
    </AdminFormSection>
  );
};
